import React from 'react';
import { useClasseContext } from '../../context/ClasseContext';
import { Download } from 'lucide-react';

/**
 * Gabarit CSV de l'import établissement : les 3 colonnes obligatoires
 * (Nom, Prénom, Classe), rien d'autre. Point-virgule (standard français),
 * BOM UTF-8 pour Excel.
 */
const ELEVES_EXEMPLE = [
  { nom: 'DUPONT', prenom: 'Benoit', classe: '6A' },
  { nom: 'MARTIN', prenom: 'Sophie', classe: '6A' },
  { nom: 'BERNARD', prenom: 'Pierre', classe: '5B' },
  { nom: 'PETIT', prenom: 'Marie', classe: '5B' },
];

const TemplateImportEleve = () => {
  const { classeNom } = useClasseContext(); // Optionnel : hors classe → exemples multi-classes

  const handleDownload = () => {
    const headers = ['Nom', 'Prénom', 'Classe'];
    const rows = ELEVES_EXEMPLE.map((e) => [e.nom, e.prenom, classeNom || e.classe]);

    let csvContent = headers.map((h) => `"${h}"`).join(';') + '\n';
    rows.forEach((cellules) => {
      csvContent += cellules.map((c) => `"${c}"`).join(';') + '\n';
    });

    // BOM UTF-8 pour qu'Excel reconnaisse correctement l'encodage
    const BOM = String.fromCharCode(0xFEFF);
    const blob = new Blob([BOM + csvContent], {
      type: 'text/csv;charset=utf-8;'
    });

    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', 'ModeleImport_Eleves.csv');
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="mt-6 flex items-center justify-center">
      <button onClick={handleDownload} className="inline-flex items-center gap-2 text-sm text-blue-600 hover:text-blue-700 transition-colors group">
        <Download size={16} className="group-hover:-translate-y-0.5 transition-transform" />
        <span>Télécharger le modèle (Nom, Prénom, Classe)</span>
      </button>
    </div>
  );
};

export default TemplateImportEleve;
